import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';

export class ObservacionsPdaFilter extends FilterData {
  codi: number;
  descripcio: string;
  tipus: string;

  constructor(sortField: string, sortDir: SortDirection) {
    super(sortField, sortDir);
    this.codi = null;
    this.descripcio = '';
    this.tipus = '';

    this.labels['codi'] = this.i18n('Codi');
    this.labels['descripcio'] = this.i18n('Descripció');
    this.labels['tipus'] = this.i18n('Tipo');
  }
}
